const pluginsPromises = import.meta.glob('./*.js')

const loadPlugins2 = function() {

  return Promise.all(Object.keys(pluginsPromises)
    .filter(file => file.indexOf('index.js') === -1)
    .map(file => pluginsPromises[file]()))
}

export default loadPlugins2

